import AddCommitmentDialog from "features/commitments/AddCommitmentModal";
import { CommitmentsTable } from "features/commitments/CommitmentsTable";
import { useClosingListSuspense } from "gen/endpoints/closing/closing";
import { useTranslation } from "react-i18next";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import invariant from "shared/utils/TinyInvariant";
import { useBoolean } from "usehooks-ts";

export const FundFamilySetupCommitmentsPage: React.FC = () => {
  const { t } = useTranslation(["common", "commitment", "commitmentClass"]);
  const { fundFamilyId } = useRequiredStringParams();

  const { data: draftClosings } = useClosingListSuspense(fundFamilyId, {
    is_draft: true,
  });

  const closing = draftClosings.at(0);
  // FIXME: Ensure backend always creates this
  invariant(closing, "No draft closings");

  const {
    value: isAddDialogOpen,
    setTrue: openAddDialog,
    setFalse: closeAddDialog,
  } = useBoolean();

  return (
    <>
      <PageContent isFullHeight={true}>
        <PageHeader title={t("common:commitments")} />
        <PageBody>
          <CommitmentsTable
            fundFamilyId={fundFamilyId}
            params={{ closing_id: closing.id }}
            onClickAddCommitment={openAddDialog}
            isSetup={true}
          />
        </PageBody>
      </PageContent>
      {isAddDialogOpen && (
        <AddCommitmentDialog
          fundFamilyId={fundFamilyId}
          closing={closing}
          onCloseComplete={closeAddDialog}
        />
      )}
    </>
  );
};
